import React from 'react';
import { translate } from 'core/utils';
import { Loader, SliderCheckBox } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const UpdateBuyShippingTemplate = ({ t, updateBuyShippingViewStore: { form, loading } }) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div>
					<div>
						<div className="ReactModal__header">
							<h3 className="spc--bottom--sml">{t('UPDATEBUYSHIPPINGVIEW.TITLE')}</h3>
						</div>
						<div className="ReactModal__body">
							<div className="message message--default spc--bottom--sml">
								<p>{t('UPDATEBUYSHIPPINGVIEW.MESSAGE')}</p>
							</div>
							<div className="input--toggle--custom spc--bottom--sml">
								<SliderCheckBox field={form.$('useBuyShipping')} />
							</div>
							{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
						</div>
						<div className="ReactModal__footer">
							<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
								{t('SAVE')}
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(UpdateBuyShippingTemplate);
